import { errorCodes, subscriptionLimits } from '@/modules/base/util/constants'
import { toast } from '@/modules/base/components/toast/toastConfig'
import { UNSAFE_openUpgradeModal as openUpgradeModal } from '@/hooks/useUpgradeModal'
import formatSizeLimitError from '@/modules/_helpers/formatSizeLimitError'
import lang from '@/lang'

const handleUploadError = (xhr, errorReason, name = '') => {
  let errorMessage = formatSizeLimitError(errorReason)
  const parsedJson = (xhr && JSON.parse(xhr.response)) || null
  if (parsedJson?.meta?.['limitation.storageSpace']?.[0].code === errorCodes.MAX_REACHED) {
    return openUpgradeModal({
      subscriptionChange: true,
      subscriptionType: 'document',
      limitReached: subscriptionLimits.STORAGE_SPACE,
    })
  } else if ((parsedJson?.meta?.['limitation.documentCount']?.[0].code === errorCodes.MAX_REACHED) || (parsedJson?.meta?.['limitation.documentCountYear']?.[0].code === errorCodes.MAX_REACHED)) {
    return openUpgradeModal({
      subscriptionChange: true,
      subscriptionType: 'document',
      limitReached: subscriptionLimits.DOCUMENT_COUNT,
    })
  } else if (parsedJson?.meta?.encryption?.[0].code === errorCodes.NOT_ALLOWED) {
    errorMessage = lang.fileUploaderSignatureEncryptionError
  } else if (parsedJson?.meta?.xml?.[0]?.code === errorCodes.NOT_SUPPORTED) {
    errorMessage = lang.receipt.multiUpload.errors.xmlNotSupported
    const splittedName = name && name.split('.')
    if (splittedName.length && splittedName[splittedName.length - 1] !== 'xml') {
      errorMessage = lang.receipt.multiUpload.errors.embeddedXmlNotSupported
    }
  }

  toast.showToast({ type: 'error', message: errorMessage })
}

export default handleUploadError
